import styled from '@emotion/styled';

export const StyledBottomSection = styled.div`
  vertical-align: bottom;
  position: absolute !important;

  display: flex;
  justify-content: space-between;

  bottom: 0;
  width: 100%;
  left: 0;
`;
